import { PREFERENCE_KEYS } from 'types/preferenceTypes';
import {
  useKineticUserQuery,
  useSaveOrganizationPreferenceMutation,
  useDeleteOrganizationPreferenceMutation,
} from '@kinetic-ui/data-layer';
import { useCallback } from 'react';

/** Low level hook that grabs all the org-wide preferences, cache-first */
export const useOrganizationWidePreferences = <TValue = Record<string, unknown>>() => {
  const { data, loading } = useKineticUserQuery({ fetchPolicy: 'cache-first' });
  const [savePreference] = useSaveOrganizationPreferenceMutation();
  const [deletePref] = useDeleteOrganizationPreferenceMutation();

  const setPreference = useCallback(
    (key: PREFERENCE_KEYS | (string & {}), value: TValue) => {
      return savePreference({
        variables: { key, value },
      });
    },
    [savePreference]
  );

  const deletePreference = useCallback(
    (key: PREFERENCE_KEYS | (string & {})) => {
      return deletePref({ variables: { key } });
    },
    [deletePref]
  );

  return {
    data: data?.organizationPreferences,
    loading,
    setPreference,
    deletePreference,
  };
};
